import React from "react";
import styled from "styled-components";


export default styled.button`
    margin-right: 15px;
`;